// ============================================================================
// AUDIT TRAIL ENDPOINTS
// ============================================================================

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';

const BASE_PATH = '/lmms/v1/audit-trail';

export const auditTrailEndpoints = {
  getAll: () => buildEndpoint(BASE_PATH),
  getByRecord: (recordType: string, recordId: string) =>
    buildEndpointWithParams(`${BASE_PATH}/:recordType/:recordId`, { recordType, recordId }),
} as const;

export default auditTrailEndpoints;
